export default "__VITE_ASSET__DPcl$hXl__"